<!-- py-12 costs 96px of an already short phone viewport; halved below sm. -->
<div
    class="fixed inset-0 w-full py-6 sm:py-12 z-50 overflow-y-auto"
    [class.pointer-events-none]="!currentModal"
>
    <app-modal
        [show]="!!currentModal"
        [size]="size()"
        [closeable]="closable"
        (close)="onClose()"
    >
        @if (currentModal?.allowBack && count > 1 && state === 'visible') {
            <!--
                From sm up this floats in its own white box to the left of the dialog.
                On a phone that position (-left-16) sits at a negative x-coordinate and
                was simply unreachable, so there it stays in the flow instead: a normal
                back button at the top of the modal, with a label to match.
            -->
            <button
                type="button"
                (click)="goBack()"
                aria-label="Vorige stap"
                class="mb-2 flex items-center gap-1 rounded-md p-2 text-sm font-medium text-ink hover:bg-soft
                       sm:absolute sm:-left-16 sm:mb-0 sm:gap-0 sm:bg-white sm:p-6 sm:hover:bg-white"
            >
                <ng-icon name="heroChevronLeftMini" size="2em" />
                <span class="sm:hidden">Terug</span>
            </button>
        }
        <div [@fadeAnimation]="state">
            <div autoAnimate>
                <ng-container #container />
            </div>
        </div>
    </app-modal>
</div>
